/* eslint-disable react-hooks/exhaustive-deps */

import { PrimeReactProvider } from "primereact/api";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Provider } from "react-redux";
import { SessionProvider } from "./auth/SessionProvider";
import { languageConstant } from "./constants/indicafix.constants";
import { acceptedLanguages } from "./locales";
import { Translated } from "./locales/helpers/translated";
import { userLanguageAdapter } from "./locales/user-language";
import { RouterProviderIntegration } from "./router/provider-integration";
import store from "./store";
import { ThemeProvider } from "./theme/ThemeProvider";

import "./locales";

function App() {
  const {
    i18n: { language, changeLanguage },
  } = useTranslation();

  useEffect(() => {
    const titles = {
      [languageConstant.PORTUGUESE]: "Indicafix - Plataforma de Pesquisa",
      [languageConstant.SPANISH]: "Indicafix - Plataforma de investigación",
      [languageConstant.ENGLISH]: "Indicafix - Research Platform",
    };
    const title = titles[language as keyof typeof titles];
    if (title) document.title = title;
  }, [language]);

  useEffect(() => {
    const previousUserLanguage = userLanguageAdapter.read();
    if (
      previousUserLanguage &&
      acceptedLanguages.includes(previousUserLanguage)
    ) {
      const timeout = setTimeout(
        () => changeLanguage(previousUserLanguage),
        100,
      );
      return () => clearTimeout(timeout);
    }
  }, [changeLanguage]);

  return (
    <Provider store={store}>
      <SessionProvider>
        <ThemeProvider>
          <Translated>
            <PrimeReactProvider>
              <RouterProviderIntegration />
            </PrimeReactProvider>
          </Translated>
        </ThemeProvider>
      </SessionProvider>
    </Provider>
  );
}

export default App;
